import axios, { AxiosError } from 'axios'
import config from 'config'
import convertObjectToQueryString from 'utils/convertObjectToQueryString'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export interface GetMakesOptions {
    condition: 'new' | 'used'
    year: number
    lenderId?: number
    disable?: boolean
    dataSource?: string[]
    assetType?: string
    assetSubType?: string
    boatType?: string
    primaryVehicleId?: number
    vehicleTypeList?: []
}

export interface Make {
    disable: boolean
    id: number
    isTrailer: boolean
    name: string
}

interface ResponseMake {
    disable: boolean
    id: number
    is_trailer: boolean
    name: string
}

export default async function getMakes(
    options: GetMakesOptions,
    abortController: AbortController,
) {
    let url = `${config.API_BASE_URL}/api/v3/vehicles/makes/`
    let dataSourceParam = ''

    if (options.dataSource) {
        dataSourceParam = options.dataSource.join(',')
    }

    const queryString = convertObjectToQueryString(
        {
            condition: options.condition,
            year: options.year,
            lender_id: options.lenderId,
            disable: options.disable,
            data_source: dataSourceParam,
            asset_type: options.assetType,
            asset_subtype: options.assetSubType,
            boat_type: options.boatType,
            primary_vehicle_id: options.primaryVehicleId,
            vehicle_type_list: options.vehicleTypeList,
            limit: 5000,
            offset: 0,
        },
        true,
    )

    url += `?${queryString}`

    try {
        const response = await axios.get(url, {
            signal: abortController.signal,
            withCredentials: true,
        })

        const makes = response.data.results.map((result: ResponseMake) => ({
            disable: result.disable,
            id: result.id,
            isTrailer: result.is_trailer,
            name: result.name,
        }))

        return makes as Make[]
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get makes: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
